import { render, staticRenderFns } from "./question-prompt.vue?vue&type=template&id=09f88caa&"
import script from "./question-prompt.vue?vue&type=script&lang=js&"
export * from "./question-prompt.vue?vue&type=script&lang=js&"
import style0 from "./question-prompt.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports